﻿import React from "react";
import {styled} from "@mui/material/styles";
import {BaseTextFieldProps, StandardTextFieldProps, TextField} from "@mui/material";
import {FormSearchAdornmentGray} from "@securspace/securspace-ui-kit";

const Root = styled(TextField)(() => ({
  ['& input::placeholder']: {
    fontSize: '1em'
  }
}));

type SortFilterTextFieldProps = StandardTextFieldProps & BaseTextFieldProps & {
  label?: string;
}

/**
 * Styled TextField with smol label and placeholder and a default placeholder if you don't wanna type it
 * @param label label passthrough used to generate a default placeholder
 * @param rest passthrough props to the internal MUI TextField. typescript will yell at you until we match versions
 *   between projects tho
 * @constructor
 */
const SortFilterTextField = ({label, ...rest}: SortFilterTextFieldProps) => {
  const placeholder = label ? `Filter results by ${label.toLowerCase()}` : '';

  return <Root variant={'standard'}
               InputProps={{
                 endAdornment: <FormSearchAdornmentGray />
               }}
               InputLabelProps={{ shrink: true }}
               label={label}
               placeholder={placeholder}
               fullWidth
               {...rest} />
};

export { SortFilterTextField };
